import './App.css';
import About from './pages/About/About';
import Authentication from './pages/Authentication/Authentication';
import Contact from './pages/Contact/Contact';
import Landing from './pages/Landing/Landing';
import PaymentForm from './pages/Payment/Payment';
import './styles/global.css'
import './styles/variables.css'
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import TermsOfServices from './pages/TermsOfServices/TermsOfServices';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import FAQ from './pages/FAQ/FAQ';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Investment from './pages/Investment/Investment';
import Profile from './pages/Profile/Profile';
import PrivateRoute from './components/PrivateRoute';
import Feed from './pages/Feed/Feed';
import FeedDetails from './components/FeedDetails/FeedDetails';
import SetupAccount from './pages/SetupAccount/SetupAccount';
import Search from './pages/Search/Search';
import Create from './pages/Create/Create';
import Wallet from './pages/Wallet/Wallet';
import Chat from './pages/Chat/Chat';
import Settings from './pages/Settings/Settings';
import EditProfile from './pages/EditProfile/EditProfile';
import AddProduct from './pages/AddProduct/AddProduct';
import StoreUnfulfilledOrders from './pages/StoreUnfulfilledOrders/StoreUnfulfilledOrders';
import StoreStatistics from './pages/StoreStatistics/StoreStatistics';
import ProfileStore from './pages/ProfileStore/ProfileStore';
import ProfilePosts from './pages/ProfilePosts/ProfilePosts';
import ProductDetails from './pages/ProductDetails/ProductDetails';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import OTPVerification from './pages/OTPVerification/OTPVerification';
import ShortInvestmentPage from './pages/ShortInvestmentPage/ShortInvestmentPage';
import Deposit from './pages/Deposit/Deposit';
import Follows from './pages/Follows/Follows';
import SavedPosts from './pages/SavedPosts/SavedPosts';
import AccountSettings from './pages/AccountSettings/AccountSettings';
import HelpFeedbacks from './pages/Help&Feedbacks/Help&Feedbacks';
import Send from './pages/Send/Send';
import QRScan from './pages/Send/QRScan';
import SendSearch from './pages/Send/SendSearch';
import Sending from './pages/Send/Sending';
import Card from './pages/Card/Card';
import Transaction from './pages/Transaction/Transaction';
import TransactionDetails from './pages/TransactionDetails/TransactionDetails';
import CurrencyConverter from './pages/CurrencyConverter/CurrencyConverter';
import Cart from './pages/Cart/Cart';
import Products from './pages/Products/Products';
import Insights from './pages/Insights/Insights';
import CustomizeStats from './pages/CustomizeStats/CustomizeStats';
import ViewProfile from './pages/ViewProfile/ViewProfile';
import ViewPost from './pages/ViewPost/ViewPost';
import ViewProduct from './pages/ViewProduct/ViewProduct';


function App() {
  return (
    <BrowserRouter>
    <ScrollToTop/>
    <Routes>
       <Route path="/" element={<Authentication />} />
       <Route path="/landing" element={<Landing/>}/>
       <Route path="/about" element={<About/>} />
       <Route path="/contact" element={<Contact/>}/>
       <Route path='/payment' element={<PaymentForm/>}/>
       <Route path='/payment-success' element={<PaymentSuccess/>}/>
       <Route path='/terms-of-services' element={<TermsOfServices/>}/>
       <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
       <Route path='/faq' element={<FAQ/>}/>
       <Route path='/investment' element={<Investment/>}/>
       <Route path='/buy-winis' element={<ShortInvestmentPage/>}/>
       <Route path='/otp-verification' element={<OTPVerification/>}/>
       <Route path='/setup-account' element={<SetupAccount/>}/>
       <Route path='/search' element={<Search/>}/>
       <Route path='/create' element={<Create/>}/>
       <Route path='/wallet' element={<Wallet/>}/>
       <Route path='/chat' element={<Chat/>}/>
       <Route path='/settings' element={<Settings/>}/>
       <Route path='/edit-profile' element={<EditProfile/>}/>
       <Route path='/customize-stats' element={<CustomizeStats/>}/>
       <Route path='/add-product' element={<AddProduct/>}/>
       <Route path='/store/unfulfilled-orders' element={<StoreUnfulfilledOrders/>}/>
       <Route path='/store/statistics' element={<StoreStatistics/>}/>
       <Route path='/deposit' element={<Deposit/>}/>
       <Route path='/follows' element={<Follows/>}/>
       <Route path='/saved' element={<SavedPosts/>}/>
       <Route path='/account-settings' element={<AccountSettings/>}/>
       <Route path='/help&feedbacks' element={<HelpFeedbacks/>}/>
       <Route path='/send' element={<Send/>}/>
       <Route path='/send/qr-scan' element={<QRScan/>}/>
       <Route path='/send/search' element={<SendSearch/>}/>
       <Route path='/sending' element={<Sending/>}/>
       <Route path='/card' element={<Card/>}/>
       <Route path='/trans' element={<Transaction/>}/>
       <Route path='/trans-details/:transactionId' element={<TransactionDetails/>}/>
       <Route path='/currency-converter' element={<CurrencyConverter/>}/>
       <Route path='/cart' element={<Cart/>}/>
       <Route path='/cart/:storeId' element={<Cart/>}/>
       <Route path='/products/:id' element={<Products/>}/>
       <Route path='/product-details/:uid/:productId' element={<ProductDetails/>}/>
       <Route path='/profile_posts/:id' element={<ProfilePosts/>}/>
       <Route path='/insights/:id' element={<Insights/>}/>
       {/* Public share / deep-link routes — keep URL shapes unchanged */}
       <Route path="/:username/:productId/:shareId/pr" element={<ViewProduct />} />
       <Route path="/:username/:userId/:shareId/u" element={<ViewProfile />} />
       <Route path="/:username/:postId/:shareId/p" element={<ViewPost />} />
       <Route path="/:username/:productId/pr" element={<ViewProduct />} />
       <Route path="/:username/:userId/:shareId" element={<ViewProfile />} />
       <Route path="/:username/:postId/:shareId" element={<ViewPost />} />
       <Route path="/:username/:userId" element={<ViewProfile />} />
       <Route path='/:id/store' element={<ProfileStore/>}/>
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
         <Route
    path="/profile/:id"
    element={
      <PrivateRoute>
        <Profile />
      </PrivateRoute>
    }
  />
        <Route path='/feed' element={<Feed/>}/>
        <Route path="/feed-details/:postId" element={<FeedDetails />} />
       {/* Username-only public profile (QR / short share links) — must be last */}
       <Route path="/:username" element={<ViewProfile />} />
    </Routes>
    
    </BrowserRouter>
    
  );
}

export default App;
